// App Store URL helpers + campaign-token attribution.
//
// The App Store ID is a public constant; the App Analytics provider token (pt)
// is account-specific and supplied via env once configured. Campaign tokens
// (ct) tag each placement so installs attribute in App Store Connect ->
// Acquisition -> Campaigns (no SDK needed). If the provider token isn't set,
// the URL still carries the ct tag and adding pt later needs no code change.

export const IOS_APP_STORE_ID =
  (import.meta.env.VITE_IOS_APP_STORE_ID as string | undefined) || '6760957676'

const PROVIDER_TOKEN = import.meta.env.VITE_IOS_PROVIDER_TOKEN as string | undefined

/** App Store product URL, optionally tagged with an App Analytics campaign token. */
export function appStoreUrl(campaignToken?: string): string {
  const base = `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`
  if (!campaignToken) return base
  const params = new URLSearchParams()
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  if (PROVIDER_TOKEN) params.set('pt', PROVIDER_TOKEN)
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  params.set('ct', campaignToken)
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  params.set('mt', '8')
  return `${base}?${params.toString()}`
}

/** Deep link that opens the App Store "write a review" sheet (for explicit buttons). */
export function writeReviewUrl(): string {
  // eslint-disable-next-line i18next/no-literal-string -- App Store URL
  return `https://apps.apple.com/app/id${IOS_APP_STORE_ID}?action=write-review`
}
